import { render, staticRenderFns } from "./HeaderUserArea.vue?vue&type=template&id=1dafa555&"
import script from "./HeaderUserArea.vue?vue&type=script&lang=js&"
export * from "./HeaderUserArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports